import React from 'react';
import { Container, CssBaseline } from '@mui/material';
import { Analytics } from "@vercel/analytics/react"
import BoardTest from './components/BoardTest';

const App: React.FC = () => {
  return (
    <>
      <CssBaseline />
      <Container>
        <BoardTest />
        <Analytics />
      </Container>
    </>
  );
};

export default App;
